import { render, staticRenderFns } from "./CreateDownload.vue?vue&type=template&id=8d59da22&scoped=true"
import script from "./CreateDownload.vue?vue&type=script&lang=js"
export * from "./CreateDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d59da22",
  null
  
)

export default component.exports